/**
 * @file workforceOptions.js
 * @description The workforce roles and rungs, as options a form can offer.
 *
 * The knowledge base seed (packages/knowledge-base/src/seed/workforce.js) is
 * the source. The browser cannot load that package, so this is a copy of the
 * two lists a person picks from — and tests/unit/masterSchemaPeople.test.js
 * fails if it ever differs from the seed, so the copy cannot drift.
 */
export const WORKFORCE_ROLES = Object.freeze([
  {
    "key": "consultant",
    "label": "Consultant"
  },
  {
    "key": "architect",
    "label": "Architect"
  },
  {
    "key": "engineer",
    "label": "Engineer"
  },
  {
    "key": "frontend_developer",
    "label": "Frontend developer"
  },
  {
    "key": "backend_developer",
    "label": "Backend developer"
  },
  {
    "key": "content",
    "label": "Content"
  },
  {
    "key": "interaction_designer",
    "label": "Interaction designer"
  },
  {
    "key": "graphics_designer",
    "label": "Graphics designer"
  },
  {
    "key": "video_editor",
    "label": "Video editor"
  },
  {
    "key": "tester",
    "label": "Tester"
  },
  {
    "key": "product_designer",
    "label": "Product designer"
  },
  {
    "key": "project_manager",
    "label": "Project manager"
  },
  {
    "key": "delivery_manager",
    "label": "Delivery manager"
  },
  {
    "key": "marketing",
    "label": "Marketing"
  },
  {
    "key": "social_media_manager",
    "label": "Social media manager"
  },
  {
    "key": "sales",
    "label": "Sales"
  },
  {
    "key": "accounting",
    "label": "Accounting"
  },
  {
    "key": "security",
    "label": "Security"
  },
  {
    "key": "devops",
    "label": "DevOps"
  },
  {
    "key": "admin",
    "label": "Admin"
  },
  {
    "key": "data_analyst",
    "label": "Data analyst"
  },
  {
    "key": "account_manager",
    "label": "Account manager"
  },
  {
    "key": "hr_manager",
    "label": "HR manager"
  },
  {
    "key": "cto",
    "label": "Chief technology officer"
  },
  {
    "key": "ceo",
    "label": "Chief executive officer"
  },
  {
    "key": "accessibility_specialist",
    "label": "Accessibility specialist"
  },
  {
    "key": "commercial_specialist",
    "label": "Procurement and commercial specialist"
  },
  {
    "key": "information_governance",
    "label": "Data protection and information governance"
  },
  {
    "key": "economist",
    "label": "Economist"
  },
  {
    "key": "ai_assurance",
    "label": "AI assurance specialist"
  },
  {
    "key": "service_assessor",
    "label": "Service assessor"
  },
  {
    "key": "policy_adviser",
    "label": "Policy adviser"
  }
]);

export const RUNGS = Object.freeze([
  {
    "ordinal": 1,
    "key": "trainee",
    "label": "Trainee",
    "autonomy": "guided"
  },
  {
    "ordinal": 2,
    "key": "junior",
    "label": "Junior",
    "autonomy": "guided"
  },
  {
    "ordinal": 3,
    "key": "support",
    "label": "Support",
    "autonomy": "supported"
  },
  {
    "ordinal": 4,
    "key": "role",
    "label": "Role",
    "autonomy": "independent"
  },
  {
    "ordinal": 5,
    "key": "senior",
    "label": "Senior",
    "autonomy": "independent"
  },
  {
    "ordinal": 6,
    "key": "team_lead",
    "label": "Team lead",
    "autonomy": "sets_direction"
  },
  {
    "ordinal": 7,
    "key": "principal",
    "label": "Principal",
    "autonomy": "sets_direction"
  },
  {
    "ordinal": 8,
    "key": "head",
    "label": "Head",
    "autonomy": "sets_direction"
  }
]);
